/* Add class='team' to the img, GUI Changes  May 15, 2026 */
/* Add p_appEnt, change cnacel to use d_imgSrcPreCrop Sep 10, 2026 */
<template lang='pug'>
	div(class="kt-image")
		div(class="viewer")
			div(v-if="d_imgSrc" class="img")
				img(ref="img" :src="d_imgSrc" :height="p_size.h" :width="p_size.w" :class="p_appEnt" )
				b-button(v-if="!p_readOnly" class="btn-delete" variant="none" @click="m_delete") 
					fa-icon(icon="times")
					span Delete
			div(v-else-if="!p_readOnly" class="upload")
				div(@click.stop.prevent="m_upload")
					fa-icon(icon="upload")
					span Upload
				input(v-show="false" ref="input" accept="image/*" type="file" @change="m_inputChange")
			div(v-else class="default")
				img(ref="img" src="@/assets/defaultPersonImage.png" :height="p_size.h" :width="p_size.w" :class="p_appEnt")
			
		b-modal(
			id="bm-kt-image-cropper" ref="bm-kt-image-cropper" size="md" 
			centered no-fade no-close-on-backdrop hide-header hide-header-close
			footer-class="pt-0 justify-content-start"
			@ok="m_cropOk"
			@cancel="m_cropCancel"
			)
			div
				img(ref="img-pre-crop" :src="d_imgSrcPreCrop" @load.stop="m_cropper" :class="p_appEnt")
			template(slot="modal-footer" slot-scope="{ ok, cancel, hide }")
				b-button(size="sm" variant="primary" @click="ok()" ) Crop
				b-button(size="sm" variant="outline-secondary" @click="cancel()" ) Cancel
				div(class="flex-grow=1")
					span {{d_imgInfo.fn}} | {{d_imgInfo.fs}} | {{d_imgInfo.w}} x {{d_imgInfo.h}}
</template>
<script>
import 'cropperjs/dist/cropper.css';
import Cropper from 'cropperjs';
import {fn_fmtFileSize} from '@/utils/util.js';
export default {
	name: "kt-image",
	components: {},
	created() {},
	mounted() {},
	data() {
		return {
			d_imgSrcPreCrop: null,
			d_imgSrc: this.p_currentVal,

			d_imgInfo: {
				fn: null,
				fs: null,
				w: null,
				h: null,
			},
			d_cropper: null,

		};

	},
	props: {
		p_currentVal: String,
		p_readOnly: Boolean,
		p_size: {type: Object, default: () => ({h: 100, w: 100})},
		p_defaultIcon: String,
		p_appEnt: String,
	},
	computed: {},
	methods: {
		m_upload() {
			let inpt = this.$refs['input'];
			inpt.value = null;
			$(inpt).trigger('click');

			this.d_imgInfo = {fn: null, fs: null, w: null, h: null};


		},
		m_delete() {
			this.d_imgSrc = this.d_imgSrcPreCrop = null;
			this.$emit('change', null);
		},
		m_inputChange(e) {
			let fileInput = e.target;
			if (fileInput.files == null || fileInput.files[0] == null) return;


			let reader = new FileReader();
			reader.onload = e => {
				this.d_imgSrcPreCrop = e.target.result;
				this.d_imgInfo.fs = fn_fmtFileSize(e.loaded);
			};

			let file = fileInput.files[0];
			reader.readAsDataURL(file);

			this.d_imgInfo.fn = file.name;

			this.$bvModal.show("bm-kt-image-cropper");
		},
		m_cropper() {
			let imgElem = this.$refs['img-pre-crop'];
			let opt = fn_getCropperOptions(this);
			this.d_cropper = new Cropper(imgElem, opt);
		},
		m_cropOk() {
			let optC = {width: this.p_size.w, height: this.p_size.h};
			let cropped = this.d_cropper.getCroppedCanvas(optC).toDataURL("image/png");
			this.$emit('change', cropped);
			this.d_imgSrc = cropped;
		},
		m_cropCancel() {
			//this.d_imgSrcPreCrop = null;
			this.d_imgSrc = this.d_imgSrcPreCrop;
			this.$emit('change', this.d_imgSrc);
		},
	},
	watch: {
		p_currentVal: function(val) {
			this.d_imgSrc = val;
		}
	}
};

function fn_getCropperOptions(vc) {
	// let minW = 100, minH = 100;
	// let maxW = 300, maxH = 300;
	return {
		aspectRatio: vc.p_size.w / vc.p_size.h,
		autoCropArea: 0,
		viewMode: 0,
		movable: true,
		zoomable: true,
		ready: (e) => {

			let d = vc.d_cropper.getImageData();
			// console.log(d);
			vc.d_imgInfo.w = d.naturalWidth;
			vc.d_imgInfo.h = d.naturalHeight;


		}

	};
}
</script>

<style scoped lang="less">
.kt-image {
	.viewer {
		display: inline-block;
		> div {
			position: relative;
			min-width: 100px;
			min-height: 100px;
			// border: solid 0.1em red;
		}
		> div.img {
			img {
				width: 150px !important;
				height: 150px !important;
				border-radius: 50% !important;
				object-fit: cover;
			}
			.btn-delete {
				display: block;
				margin: 0 auto;
				padding: 0em 0.2em;
				line-height: 1em;
				background-color: rgba(248, 249, 250, 0.7);
				opacity: 0.5;

				svg {
					color: #dc3545;
					margin: 0 0.2em;
				}
				span {
					font-size: 0.9em;
				}
				&:hover {
					opacity: unset;
				}
			}
		}
		> div.upload > div {
			display: flex;
			flex-wrap: wrap;
			min-height: inherit;
			background-color: #f8f9fa;
			color: #adb5bd;
			cursor: pointer;

			svg {
				font-size: 1.5em;
				margin: auto;
				margin-bottom: 0.2em;
			}
			span {
				display: inline-block;
				font-size: 0.9em;
				width: 100%;
				text-align: center;
			}
			&:hover {
				color: #4fa4ff;
				box-shadow: 0em 0.05em 0.1em 0.05em #e9ecef;
				// border-color: #adb5bd;
			}
		}
		> div.default {
			display: flex;
			color: #adb5bd;
			background-color: #f8f9fa;
			svg {
				font-size: 3em;
				margin: auto;
			}
		}
	}
}

#bm-kt-image-cropper {
	.modal-content {
		.modal-body {
			padding: 0.2em;
			img {
				display: block;
				max-width: 100%;
			}
		}
		.modal-footer {
			margin-top: 0.5em;
			padding: 0.5em 0.2em;
			> div {
				flex-grow: 1;
				text-align: right;
				font-size: 0.8em;
			}
		}
	}
}
.image-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover !important;
  border-radius: 50%;
}
img.team{
  width: 150px !important;
  height: 150px !important;
  border-radius: 50% !important;
  object-fit: cover;
}

</style>